// Copyright (c) Microsoft. All rights reserved.

import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import React from 'react';
import { IChatMessage } from '../../../libs/models/ChatMessage';
import * as utils from './../../utils/TextUtils';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const useClasses = makeStyles({
    content: {
        wordBreak: 'break-word',
        '& p': {
            marginTop: '0',
            marginBottom: '0',
        },
        '& pre': {
            backgroundColor: tokens.colorNeutralBackground6,
            color: tokens.colorNeutralForeground1,
            ...shorthands.padding('15px'),
            
        },
        '& code': {
            textWrap: 'wrap',
            ...shorthands.borderRadius('5px'),
        },
    },
});

interface ChatHistoryTextContentProps {
    message: IChatMessage;
}

export const ChatHistoryTextContent: React.FC<ChatHistoryTextContentProps> = ({ message }) => {
    const classes = useClasses();

    let content =
        message.content === '{}' ? "I am sorry, but I can't find anything related to your question." : message.content;
    content = utils.formatChatTextContent(content);

    return (
        <div className={classes.content}>
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
        </div>
    );
};
